<template>
  <div class="form-elements">
    <div class="row">
      <div class="flex xs12">
        <form @submit.prevent>
          <va-card :title="$t('forms.inputs.palletProduct')+ ': ' + this.$route.params.pallet_type_name">
            <div class="row">
              <div class="flex xs12">
                <div class="row">
                  <div class="flex md4 sm6 xs12">
                    <va-input
                      :label="$t('forms.inputs.searchProduct')"
                      v-model="productSearch.name"
                      @focus="searchResult = false, add_button_disabled = true, product.id = ''"
                    />
                  </div>

                  <div class="flex md1 sm1 xs12">
                    <va-button
                      small
                      color="secondary"
                      icon="fa fa-search"
                      class="mr-1"
                      @click="getProduct()"
                    />
                    <va-button
                      small
                      color="secondary"
                      icon="fa fa-close"
                      class="mr-1"
                      @click="resetlabels()"
                    />
                  </div>

                  <div class="flex xs12 md3 offset--md3">
                    <va-select
                      v-model="perPage"
                      :value="perPage"
                      :label="$t('tables.perPage')"
                      :options="perPageOptions"
                    />
                  </div>

                </div>

                <div class="row" v-if="searchResult == true">
                  <div class="flex md4 sm6 xs12">
                    <va-select
                      :label="$t('forms.inputs.product')"
                      v-model="product.id"
                      keyBy="id"
                      textBy="name"
                      :options="productsList"
                      noOptionsText="Nenhum produto encontrado"
                    />
                  </div>
                </div>

                <div class="row">
                  <div class="flex md2 sm6 xs12">
                    <va-button
                      medium
                      inline
                      color="greenLight"
                      icon="fa fa-plus"
                      class="ma-0"
                      :disabled="add_button_disabled"
                      @click="addProductToPalletProducts(product.id, $route.params.id, $store.state.currentLocality.id)"
                    >
                      {{ $t('menu.add') }}
                    </va-button>
                  </div>

                  <div class="flex md2 sm6 xs12">
                    <va-button
                      medium
                      inline
                      color="secondary"
                      icon="fa fa-cloud-upload"
                      class="ma-0"
                      :to="{ name: 'import-pallet-products', params: { palletTypeId: this.palletTypeId, id: this.$route.params.id } }"
                    >
                      {{ $t('menu.import') }}
                    </va-button>
                  </div>

                  <div class="flex md2 sm6 xs12">
                    <va-button
                      medium
                      inline
                      color="green"
                      icon="fa fa-plus-circle"
                      class="ma-0"
                      @click="showModalAddAll = true"
                    >
                      {{ $t('menu.addAll') }}
                    </va-button>
                  </div>

                  <div class="flex md2 sm6 xs12">
                    <va-button
                      medium
                      inline
                      color="secondary"
                      icon="fa fa-remove"
                      class="ma-0"
                      @click="showModalRemoveAll = true"
                    >
                      {{ $t('menu.removeAll') }}
                    </va-button>
                  </div>

                  <div class="flex md2 sm6 xs12">
                    <va-button
                      medium
                      inline
                      color="#ff842b"
                      icon="fa fa-chevron-left"
                      class="ma-0"
                      @click="goBack()">
                      {{ $t('menu.back') }}
                    </va-button>
                  </div>
                </div>

                <div v-show="loading" class="text--center pb-4">
                  <div class="flex-center spinner-box">
                    <slot name="loading">
                      <spring-spinner
                        slot="loading"
                        :animation-duration="currentDuration"
                        :is="spload.name"
                        :color="spinnersColor"
                        :size="config.size"
                      />
                    </slot>
                  </div>
                </div>

                <va-data-table
                  v-if="renderComponent"
                  :fields="fields"
                  :data="products"
                  :per-page="parseInt(perPage)"
                  :total-pages="parseInt(totalPages)"
                  v-show="!loading"
                  no-pagination
                  api-mode
                  @page-selected="readItems"
                >
                  <template slot="actions" slot-scope="props">
                    <va-button
                      small
                      inline
                      color="danger"
                      icon="fa fa-remove"
                      class="ma-0"
                      @click="showModalRemove = true, id_to_remove = props.rowData.id"
                    >
                      {{ $t('tables.delete') }}
                    </va-button>
                  </template>
                </va-data-table>

                  <Pagination
                    :currentPage="current_page"
                    :totalPages="totalPages"
                    :onChange="onPageChange"
                    v-show="!loading"
                  />
                  <va-modal
                    v-model="showModalRemove"
                    size="small"
                    :title="$t('modal.remove')"
                    :message="$t('modal.messageRemoveProductFromPalletProducts')"
                    hideDefaultActions
                    :color="this.$themes.secondary"
                  >
                  <va-button
                    color="danger"
                    class="ma-2"
                    @click="showModalRemove = false">
                    {{$t('modal.cancel')}}
                  </va-button>

                  <va-button
                    color="green"
                    class="ma-2"
                    @click="removeProductFromPalletProducts(id_to_remove), showModalRemove = false">
                    {{$t('modal.confirm')}}
                  </va-button>
                  </va-modal>

                  <va-modal
                    v-model="showModalRemoveAll"
                    size="small"
                    :title="$t('modal.remove')"
                    :message="$t('modal.messageRemoveAllProductsFromPalletProducts')"
                    hideDefaultActions
                    :color="this.$themes.secondary"
                  >
                  <va-button
                    color="danger"
                    class="ma-2"
                    @click="showModalRemoveAll = false">
                    {{$t('modal.cancel')}}
                  </va-button>

                  <va-button
                    color="green"
                    class="ma-2"
                    @click="removeAllProducts($route.params.id, $store.state.currentLocality.id), showModalRemoveAll = false">
                    {{$t('modal.confirm')}}
                  </va-button>
                </va-modal>

                <va-modal
                    v-model="showModalAddAll"
                    size="small"
                    :title="$t('modal.confirm')"
                    :message="$t('modal.messageAddAllProductsFromPalletProducts')"
                    hideDefaultActions
                    :color="this.$themes.secondary"
                  >
                  <va-button
                    color="danger"
                    class="ma-2"
                    @click="showModalAddAll = false">
                    {{$t('modal.cancel')}}
                  </va-button>

                  <va-button
                    color="green"
                    class="ma-2"
                    @click="addAllProducts($route.params.id, $store.state.currentLocality.id), showModalAddAll = false">
                    {{$t('modal.confirm')}}
                  </va-button>
                </va-modal>
              </div>
            </div>
          </va-card>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import PalletProductAPI from '@/services/PalletProductAPI'
import ProductAPI from '@/services/ProductAPI'
import Pagination from '../../shared/Pagination'
import * as spinners from 'epic-spinners'
import { showError } from '@/global'

export default {
  name: 'form-pallet-type-setup',
  components: {
    ...spinners,
    Pagination,
  },
  data () {
    return {
      showModalRemove: false,
      showModalRemoveAll: false,
      showModalAddAll: false,
      add_button_disabled: true,
      id_to_remove: '',
      product: {
        id: '',
        name: '',
      },
      productSearch: {
        name: '',
      },
      pallet_type_id: '',
      products: [],
      productsList: [],
      searchResult: false,
      renderComponent: true,
      spinnersColor: this.$themes.secondary,
      currentDuration: 1500,
      config: {
        size: 80,
        group: 4,
        duration: 1500,
      },
      loading: false,
      perPage: '10',
      totalPages: 0,
      perPageOptions: ['10', '20', '30', '50'],
      current_page: '',
      pallet_type_setup: {
        id: '',
        quantity_limitation: '',
        limit_quantity: '',
        minimal_cubage: '',
        specific_products: '',
      },
      palletTypeId: new FormData(),
    }
  },

  mounted () {
    this.palletTypeId.append('pallet_type_id', this.$route.params.id)
    this.readItems()
  },

  watch: {
    perPage: function (newVal) {
      this.perPage = newVal
      this.readItems(this.current_page)
    },
    '$store.state.currentLocality': function () {
      this.readItems()
    },
    'product.id': function () {
      if (this.product.id !== '') {
        this.add_button_disabled = false
      } else {
        this.add_button_disabled = true
      }
    },
  },

  methods: {
    async readItems (page = 1) {
      this.loading = true

      const params = {
        page: page,
        quantity: this.perPage,
        pallet_type_id: this.$route.params.id || this.$router.history.current.params.id,
        locality_id: this.$store.state.currentLocality.id,
      }
      this.current_page = this.$route.params.current_page

      await PalletProductAPI.getAllPalletProductsByPalletTypeAndLocality(params).then(response => {
        this.products = response.data.pallet_products
        this.totalPages = response.data.total_pages
        this.current_page = response.data.current_page
        this.loading = false
      }).catch(e => {
        this.loading = false
        showError(e)
      })
    },

    goBack () {
      this.$router.push({
        name: 'form-pallet-type-setup',
        params: {
          id: this.$route.params.id,
          pallet_type_name: this.$route.params.pallet_type_name,
        },
      })
    },

    onPageChange (page) {
      this.readItems(page)
    },
    forceRerender () {
      this.renderComponent = false

      this.$nextTick(() => {
        this.renderComponent = true
      })
    },

    getProduct () {
      ProductAPI.getProductByName(this.productSearch.name).then(response => {
        this.productsList = response.data.products
        this.searchResult = true
      })
    },

    async addProductToPalletProducts (product, palletTypeId, localityId) {
      let productId = ''

      if (typeof product === 'object') {
        productId = product.id
      }

      const params = {
        product_id: productId,
        pallet_type_id: palletTypeId,
        locality_id: localityId,
      }

      await PalletProductAPI.createPalletProduct(params).then(response => {
        this.loading = true
        this.resetlabels()
        this.readItems()
        this.loading = false
        this.showToast(response.data.message, {
          icon: 'fa-thumbs-o-up',
          position: 'top-right',
          duration: 5000,
        })
      }).catch(e => {
        this.showToast(e.response.data.error, {
          icon: 'fa-thumbs-o-down',
          position: 'top-right',
          duration: 5000,
        })
      })
    },

    async addAllProducts (palletTypeId, localityId) {
      const params = {
        pallet_type_id: palletTypeId,
        locality_id: localityId,
      }
      this.loading = true
      await PalletProductAPI.addAllProducts(params).then(response => {
        this.resetlabels()
        this.readItems()
        this.loading = false
        this.showToast(response.data.message, {
          icon: 'fa-thumbs-o-up',
          position: 'top-right',
          duration: 5000,
        })
      }).catch(e => {
        this.showToast(e.response.data.error, {
          icon: 'fa-thumbs-o-down',
          position: 'top-right',
          duration: 5000,
        })
      })
    },

    async removeAllProducts (palletTypeId, localityId) {
      const params = {
        pallet_type_id: palletTypeId,
        locality_id: localityId,
      }
      this.loading = true
      await PalletProductAPI.removeAllProducts(params).then(response => {
        this.resetlabels()
        this.readItems()
        this.loading = false
        this.showToast(response.data.message, {
          icon: 'fa-thumbs-o-up',
          position: 'top-right',
          duration: 5000,
        })
      }).catch(e => {
        this.showToast(e.response.data.error, {
          icon: 'fa-thumbs-o-down',
          position: 'top-right',
          duration: 5000,
        })
      })
    },

    removeProductFromPalletProducts (id) {
      PalletProductAPI.removePalletProduct(id).then(response => {
        this.loading = true
        this.readItems()
        this.loading = false
        this.showToast(response.data.message, {
          icon: 'fa-thumbs-o-up',
          position: 'top-right',
          duration: 5000,
        })
      }).catch(e => {
        this.showToast(e.response.data.error, {
          icon: 'fa-thumbs-o-down',
          position: 'top-right',
          duration: 5000,
        })
      })
    },

    resetlabels () {
      this.productSearch.name = ''
      this.product.name = ''
      this.product.id = ''
      this.add_button_disabled = true
      this.searchResult = false
    },
  },

  computed: {
    fields () {
      return [{
        name: 'productId',
        title: this.$t('tables.products.id'),
        width: '3%',
      },
      {
        name: 'product_name',
        title: this.$t('tables.products.label'),
        width: '25%',
      },
      {
        name: 'fragility',
        title: this.$t('tables.packages.fragility'),
        width: '10%',
      },
      {
        name: 'package',
        title: this.$t('tables.packages.name'),
        width: '10%',
      },
      {
        name: 'address',
        title: this.$t('tables.product_sequence.address'),
        width: '15%',
      },
      {
        name: 'integration_id',
        title: this.$t('tables.products.staging'),
        width: '15%',
      },
      {
        name: '__slot:actions',
        dataClass: 'text-right',
      }]
    },

    spload () {
      // return spinners.SpinnerName
      return spinners.ScalingSquaresSpinner
    },
  },
}
</script>
